import type { CabinetMfaEnrollment } from "@planerius/contracts/cabinet-auth"

/**
 * Начатое заведение второго фактора при входе.
 *
 * Хранится в памяти вкладки по той же причине, что и билет на ввод кода: enrollToken —
 * половина доступа, и localStorage отдал бы его первой же XSS. Живёт он пять минут,
 * поэтому переживать F5 ему незачем: после обновления человек возвращается к паролю.
 */
let enrollment: CabinetMfaEnrollment | null = null

export const enrollChallengeStore = {
  read(): CabinetMfaEnrollment | null {
    if (enrollment === null) return null
    if (Date.parse(enrollment.expiresAt) <= Date.now()) {
      enrollment = null
      return null
    }
    return enrollment
  },

  write(next: CabinetMfaEnrollment): void {
    enrollment = next
  },

  clear(): void {
    enrollment = null
  },
}
